import * as o from "react";
import a from "../lib/IconBase.es.js";
import c from "../defs/ChatCircleDots.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: c }));
t.displayName = "ChatCircleDotsIcon";
const m = t;
export {
  m as ChatCircleDots,
  t as ChatCircleDotsIcon
};
